import {
  grayColor,
  defaultFont,
  subSidebarWidth
} from "assets/jss/index.js";

const commonStyle = {
  labelRoot: {
    ...defaultFont,
    color: grayColor[3] + " !important",
    fontWeight: "400",
    fontSize: "10px",
    lineHeight: "2",
    letterSpacing: "unset"
  },

  addButton: {
    marginBottom: 15,
    position: "relative",
    zIndex: 20,
  },

  tableButton: {
    height: "30px",
    padding: "0 10px",
    margin: 0
  },
  tableButton2: {
    height: "30px",
    padding: 0,
    margin: 0,
    fontSize: '30px',
    cursor: 'pointer'
  },

  subSidebarPadding: {
    marginLeft: subSidebarWidth,
  },

  flexBox: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",

    '& button': {
      marginBottom: 10,
      marginLeft: 5,
    }
  },
  pageTitle: {
    marginBottom: "20px",
    textTransform: "inherit",
    "& span:after": {
      content: '"/"',
      display: "inline-block",
      margin: "0 8px"
    },
    "& span:last-child:after": {
      content: '" "',
    }
  },
  textCenter: {
    textAlign: "center"
  },
  switchLabel: {
    fontSize: ".85rem",
    color: "rgba(0,0,0,.65)",
  },
};

export default commonStyle;
